export const requestConfig = {
  // url: 'https://shop.tianzheng.warnny.com',
  url: 'https://zxapi.tengen.com.cn',
  //url: 'http://localhost:8111',
  // url: '/proxy',
  timeout: 30000
}
